import I18n from 'I18n';
const getAssociationLabelHelp = ({
  associationDefinition,
  shouldUseAlternateAllAssociationsLabel
}) => {
  if (!associationDefinition) {
    return '';
  }
  if (shouldUseAlternateAllAssociationsLabel && associationDefinition.hasAllAssociatedObjects) {
    return I18n.text('automation-ui-associations.flexible-associations.alternate-default-label-with-inverse-label');
  }
  if (associationDefinition.hasAllAssociatedObjects || associationDefinition.isPrimary || !associationDefinition.inverseLabel) {
    return '';
  }
  return I18n.text('automation-ui-associations.flexible-associations.default-label-with-inverse-label', {
    inverseLabel: associationDefinition.inverseLabel
  });
};
export default getAssociationLabelHelp;